import { React, useState, useEffect, useRef } from 'react'
import { motion } from "framer-motion";
import { Helmet } from 'react-helmet'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelopeOpenText, faLock, faArrowRight, faCircleInfo, faUserPlus, faFingerprint } from '@fortawesome/free-solid-svg-icons'
import { browserSupportsWebAuthn, startAuthentication } from '@simplewebauthn/browser'

import MainHeader from '../../components/MainHeader/MainHeader.js'
import MainFooter from '../../components/MainFooter/MainFooter.js'
import CTAButton from '../../components/CTAButton/CTAButton.js'

import { lP, oP, sT, boxvar2_1, boxvar4, URL_MAINAPI, API_TOKEN, formatDateWithTime, capFirstChar, describePasskeyError } from '../../main.js'

import '../../main.css'
import './Login.css'
import './MLogin.css'

import img_not_found from '../../assets/pictures/imgnotfound.webp'

import Cookies from 'universal-cookie'
const cookies = new Cookies()

export default function Login() {

    var eventid = new URLSearchParams(window.location.search).get("eventid");
    var [eventFound, setEventFound] = useState(1)

    var [loginTab, setLoginTab] = useState('pw')
    var loginTabRef = useRef('pw')

    var [formError, setFormError] = useState(false)
    var [resError, setResError] = useState("")
    var [pwNoPassword, setPwNoPassword] = useState(false)

    var passkeySupported = browserSupportsWebAuthn()
    var [passkeyStatus, setPasskeyStatus] = useState("")
    var [passkeyError, setPasskeyError] = useState("")

    var [formData, setFormData] = useState({
        formVorname: "",
        formNachname: "",
        formMail: "",
        formPasswort: "",
    })

    // Ref hält immer den aktuellen formData-Stand,
    // damit die Enter-Handler (im []-useEffect registriert) nicht
    // über ein veraltetes Closure auf leere Werte zugreifen.
    var formDataRef = useRef(formData)
    formDataRef.current = formData

    var [eventData, setEventData] = useState({
        eventId: "",
        eventName: "",
        eventLongName: "Event wird geladen...",
        eventLogo: img_not_found,
        eventHeroImg: img_not_found,
        eventURL: "#",
        eventImprintURL: "#",
        eventOrganizator: "unbekannt",
        eventContactURL: "#",
        eventContactMail: "",
        eventContactTel: "",
        eventSlogan: "Mach mit!",
        eventApplicationActive: false,
        eventDates: {
            dateStart: "",
            dateEnd: "",
            applicationStart: "",
            applicationEnd: ""
        },
        eventStyle: {
            colorPrimary: '#662773',
            colorPrimaryGradient: '#986da0',
            colorSecondary: '#94b654',
            colorTileBg: '#f6deff',
            colorStdText: '#000000',
            colorBtnText: '#ffffff',
            colorStdTextOnTile: '#000000'
        },
        eventInfo: {
            box1Header: "Was ist das",
            box1Text: "Eventbeschreibung wird geladen...",
            box1HeroImg: null,
            box2Header: "Deine Aufgaben",
            box2Text1: "Aufgabenbeschreibung wird geladen...",
            box2Text2: "",
            box2CtaText: "Registrieren",
            box3Header: "Eckdaten",
            box3Contents: "",
            box3LookingFor: "",
            box3Text: "Weitere Fragen an den Veranstalter?",
            box3CtaText: "Kontakt"
        }
    })

    useEffect(() => {
        setFormData({
            ...formData,
            formMail: new URLSearchParams(window.location.search).get("formMail") || "",
            formVorname: new URLSearchParams(window.location.search).get("formVorname") || "",
            formNachname: new URLSearchParams(window.location.search).get("formNachname") || ""
        });

        if (eventid == "0" || eventid == null) { } else {
            getEventData()
        }

        const listener = event => {
            if (event.code === "Enter" || event.code === "NumpadEnter") {
                if (loginTabRef.current === 'pw') {
                    doLoginPW()
                } else {
                    doLoginRequest()
                }
            }
        }
        document.addEventListener("keydown", listener)
        return () => {
            document.removeEventListener("keydown", listener)
        }
    }, [])

    function switchLoginTab(tab) {
        setLoginTab(tab)
        loginTabRef.current = tab
        setFormError(false)
        setResError("")
        setPwNoPassword(false)
    }

    function getEventData() {
        try {
            fetch(URL_MAINAPI + "/event/" + eventid, {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN
                },
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    setEventFound(1)
                    applyEventData(res.data);
                } else {
                    setEventFound(0)
                }
            }))
        } catch (err) {
            setEventFound(0)
        }
    }

    function applyEventData(metadata) {
        setEventData({
            eventId: metadata._id,
            eventName: metadata.name,
            eventLongName: metadata.longname,
            eventLogo: metadata.logo_img,
            eventHeroImg: metadata.hero_img,
            eventURL: metadata.url,
            eventOrganizator: metadata.organization.name,
            eventContactURL: metadata.organization.contact.url,
            eventImprintURL: metadata.organization.contact.imprint_url,
            eventContactMail: metadata.organization.contact.email,
            eventContactTel: metadata.organization.contact.tel,
            eventSlogan: metadata.slogan,
            eventApplicationActive: metadata.applicationActive,
            eventDates: {
                dateStart: metadata.dates.dateStart,
                dateEnd: metadata.dates.dateEnd,
                applicationStart: metadata.dates.applicationStart,
                applicationEnd: metadata.dates.applicationEnd
            },
            eventCustomStyle: metadata.customstyle,
            eventStyle: {
                colorPrimary: metadata.style.colorPrimary,
                colorPrimaryGradient: metadata.style.colorPrimaryGradient,
                colorSecondary: metadata.style.colorSecondary,
                colorTileBg: metadata.style.colorTileBg,
                colorStdText: metadata.style.colorStdText,
                colorBtnText: metadata.style.colorBtnText,
                colorStdTextOnTile: metadata.style.colorStdTextOnTile
            },
            eventInfo: {
                box1Header: metadata.info.box1Header,
                box1Text: metadata.info.box1Text,
                box1HeroImg: metadata.info.box1HeroImg,
                box2Header: metadata.info.box2Header,
                box2Text1: metadata.info.box2Text1,
                box2Text2: metadata.info.box2Text2,
                box2CtaText: metadata.info.box2CtaText,
                box3Header: metadata.info.box3Header,
                box3Contents: metadata.info.box3Contents,
                box3LookingFor: metadata.info.box3LookingFor,
                box3Text: metadata.info.box3Text,
                box3CtaText: metadata.info.box3CtaText
            }
        });

        if (metadata.customstyle) {
            document.documentElement.style.setProperty('--event_color_primary', metadata.style.colorPrimary);
            document.documentElement.style.setProperty('--event_color_primarygradient', metadata.style.colorPrimaryGradient);
            document.documentElement.style.setProperty('--event_color_secondary', metadata.style.colorSecondary);
            document.documentElement.style.setProperty('--event_color_tilebg', metadata.style.colorTileBg);
            document.documentElement.style.setProperty('--event_color_stdtext', metadata.style.colorStdText);
            document.documentElement.style.setProperty('--event_color_stdtextontile', metadata.style.colorStdTextOnTile);
            document.documentElement.style.setProperty('--event_color_btntext', metadata.style.colorBtnText);
        }
    }

    function completeLogin(data) {
        cookies.set('userid', data.userid, { path: '/' })
        cookies.set('authtoken', data.authtoken, { path: '/' })
        cookies.set('firstname', data.firstname, { path: '/' })
        cookies.set('lastname', data.lastname, { path: '/' })
        if (eventid != null && eventid != "0") {
            lP('/event/' + eventid)
        } else {
            lP("/profil")
        }
    }

    async function doLoginPasskey() {
        setPasskeyStatus("loading")
        setPasskeyError("")
        const headers = {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'APITOKEN': API_TOKEN
        }

        try {
            const optionsRes = await fetch(URL_MAINAPI + "/auth/passkey/login-options", { method: "POST", headers: headers })
            const optionsData = await optionsRes.json()
            if (optionsRes.status !== 200) {
                setPasskeyStatus("error")
                setPasskeyError(optionsData.error)
                return
            }

            const assertion = await startAuthentication({ optionsJSON: optionsData.options })

            const loginRes = await fetch(URL_MAINAPI + "/auth/passkey/login", {
                method: "POST",
                headers: headers,
                body: JSON.stringify({ challengeId: optionsData.challengeId, response: assertion, eventid: eventid }),
            })
            const loginData = await loginRes.json()
            if (loginRes.status === 200) {
                setPasskeyStatus("done")
                completeLogin(loginData)
            } else {
                setPasskeyStatus("error")
                setPasskeyError(loginData.error)
            }
        } catch (err) {
            const message = describePasskeyError(err)
            setPasskeyStatus(message ? "error" : "")
            setPasskeyError(message || "")
        }
    }

    function doLoginPW() {
        document.querySelector("#pw_responseInfo_loading").style.display = "block"
        document.querySelector("#pw_responseInfo_done").style.display = "none"
        document.querySelector("#pw_responseInfo_servererror").style.display = "none"
        document.querySelector("#pw_responseInfo_wronginput").style.display = "none"
        setPwNoPassword(false)

        var currentData = formDataRef.current
        var reqbody = {
            "email": currentData.formMail,
            "password": currentData.formPasswort,
        }

        try {
            fetch(URL_MAINAPI + "/auth/login-pw", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN
                },
                body: JSON.stringify(reqbody),
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    document.querySelector("#pw_responseInfo_done").style.display = "block"
                    document.querySelector("#pw_responseInfo_loading").style.display = "none"
                    document.querySelector("#pw_responseInfo_servererror").style.display = "none"
                    document.querySelector("#pw_responseInfo_wronginput").style.display = "none"
                    setResError("");
                    completeLogin(res.data)
                } else {
                    document.querySelector("#pw_responseInfo_loading").style.display = "none"
                    document.querySelector("#pw_responseInfo_wronginput").style.display = "block"
                    setResError(res.data.error);
                    if (res.data.nopassword === true || /passwort/i.test(String(res.data.error || ""))) {
                        setPwNoPassword(true)
                    }
                }
            }))
        } catch (err) {
            document.querySelector("#pw_responseInfo_loading").style.display = "none"
            document.querySelector("#pw_responseInfo_servererror").style.display = "block"
            setResError(err);
        }
    }

    function doLoginRequest() {
        document.querySelector("#mail_responseInfo_loading").style.display = "block"
        document.querySelector("#mail_responseInfo_done").style.display = "none"
        document.querySelector("#mail_responseInfo_servererror").style.display = "none"
        document.querySelector("#mail_responseInfo_wronginput").style.display = "none"

        var currentData = formDataRef.current
        var reqbody = {
            "firstname": currentData.formVorname,
            "lastname": currentData.formNachname,
            "email": currentData.formMail,
            "eventid": eventid
        }

        try {
            fetch(URL_MAINAPI + "/auth/login", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN
                },
                body: JSON.stringify(reqbody),
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    document.querySelector("#mail_responseInfo_done").style.display = "block"
                    document.querySelector("#mail_responseInfo_loading").style.display = "none"
                    document.querySelector("#mail_responseInfo_servererror").style.display = "none"
                    document.querySelector("#mail_responseInfo_wronginput").style.display = "none"
                    setResError("");
                } else {
                    document.querySelector("#mail_responseInfo_loading").style.display = "none"
                    document.querySelector("#mail_responseInfo_wronginput").style.display = "block"
                    setResError(res.data.error);
                }
            }))
        } catch (err) {
            document.querySelector("#mail_responseInfo_loading").style.display = "none"
            document.querySelector("#mail_responseInfo_servererror").style.display = "block"
            setResError(err);
        }
    }

    return (
        <div className='mainCon page' id='mainCon'>
            <MainHeader selectedsite={""} />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Login</title>
                <meta property="og:title" content="Login" />
                <meta property="og:description" content="Logge dich hier in den Helferzeit-Konto ein." />
            </Helmet>

            <main className='page-body'>
                <div className='auth-wrap'>
                    <div className='auth-head'>
                        <div className='section-eyebrow'>Willkommen zurück</div>
                        <h1>Bei Helferzeit anmelden</h1>
                        <p>Melde dich mit Passkey oder Passwort an – oder per E-Mail-Link, falls du noch keins von beidem eingerichtet hast.</p>
                    </div>

                    <motion.div
                        variants={boxvar2_1}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: false, margin: "-50px" }}
                        className='auth-grid'
                    >
                        <div className='card auth-card'>
                            {(passkeySupported) ? (
                                <div className='auth-passkey'>
                                    <CTAButton
                                        variant="primary"
                                        block={true}
                                        hideArrow={true}
                                        disabled={passkeyStatus === "loading"}
                                        title={<><FontAwesomeIcon icon={faFingerprint} /> Mit Passkey anmelden</>}
                                        onclick={() => doLoginPasskey()}
                                    />
                                    <p className='auth-passkey-hint'>Mit Face ID, Touch ID, Windows Hello oder deinem Passwortmanager (z. B. 1Password).</p>

                                    {(passkeyStatus === "loading") ? (
                                        <p className='status-banner status-banner--info' role="status">Bitte bestätige den Login in deinem Passkey-Dialog…</p>
                                    ) : null}
                                    {(passkeyStatus === "done") ? (
                                        <p className='status-banner status-banner--success' role="status">Erfolgreich. Du bist jetzt eingeloggt.</p>
                                    ) : null}
                                    {(passkeyStatus === "error") ? (
                                        <p className='status-banner status-banner--error' role="alert">
                                            <span>Login mit Passkey fehlgeschlagen.<br />Fehler: {passkeyError}</span>
                                        </p>
                                    ) : null}

                                    <div className='login-divider'><span>oder</span></div>
                                </div>
                            ) : null}

                            <div className='auth-tabs'>
                                <button
                                    type="button"
                                    className={'auth-tab' + (loginTab === 'pw' ? ' auth-tab-active' : '')}
                                    onClick={() => switchLoginTab('pw')}
                                >
                                    <FontAwesomeIcon icon={faLock} /> Passwort
                                </button>
                                <button
                                    type="button"
                                    className={'auth-tab' + (loginTab === 'mail' ? ' auth-tab-active' : '')}
                                    onClick={() => switchLoginTab('mail')}
                                >
                                    <FontAwesomeIcon icon={faEnvelopeOpenText} /> Per E-Mail
                                </button>
                            </div>

                            {(loginTab === 'pw') ? (
                                <div>
                                    <h2><FontAwesomeIcon icon={faLock} /> Login mit Passwort</h2>
                                    <p>Melde dich mit deiner E-Mail-Adresse und deinem Passwort an.</p>

                                    <form>
                                        <div className="field">
                                            <label htmlFor="pw-mail">Deine E-Mail-Adresse</label>
                                            <input
                                                id="pw-mail"
                                                type="email"
                                                className="in_mail"
                                                name="mail"
                                                placeholder="E-Mail"
                                                autoFocus
                                                value={formData.formMail}
                                                autoComplete='email'
                                                onInput={(e) => setFormData(prev => ({ ...prev, formMail: e.target.value }))}
                                            />
                                        </div>
                                        <div className="field">
                                            <label htmlFor="pw-passwort">Dein Passwort</label>
                                            <input
                                                id="pw-passwort"
                                                type="password"
                                                className="in_passwort"
                                                name="passwort"
                                                placeholder="Passwort"
                                                value={formData.formPasswort}
                                                autoComplete='current-password'
                                                onInput={(e) => { setFormData(prev => ({ ...prev, formPasswort: e.target.value })); setFormError(false); }}
                                            />
                                        </div>

                                        {(formError) ? (
                                            <span className="error-msg"><FontAwesomeIcon icon={faCircleInfo} /> Bitte fülle alle Pflichtfelder korrekt aus.</span>
                                        ) : null}

                                        <CTAButton variant="primary" block={true} title={"Einloggen"} onclick={() => doLoginPW()} />

                                        <p className="responseInfo" id="pw_responseInfo_loading">Lädt... Bitte warten...</p>
                                        <p className="responseInfo" id="pw_responseInfo_wronginput">
                                            Bitte überprüfe deine Eingaben!<br />
                                            Fehler: {resError}
                                        </p>
                                        <p className="responseInfo" id="pw_responseInfo_servererror">
                                            Es gab einen Fehler bei der Verarbeitung.<br />
                                            Fehler: {resError}
                                        </p>
                                        <p className="responseInfo" id="pw_responseInfo_done">Erfolgreich. Du bist jetzt eingeloggt.</p>

                                        {(pwNoPassword) ? (
                                            <div className='auth-note'>
                                                <FontAwesomeIcon icon={faCircleInfo} />
                                                <div>
                                                    Für dein Konto ist noch kein Passwort gesetzt. Nutze den <a href="#" onClick={(e) => { e.preventDefault(); switchLoginTab('mail') }}>E-Mail-Login</a> und richte danach unter Profil → Accountsicherheit einen Passkey oder ein Passwort ein.
                                                </div>
                                            </div>
                                        ) : null}
                                    </form>
                                </div>
                            ) : (
                                <div>
                                    <h2><FontAwesomeIcon icon={faEnvelopeOpenText} /> Login per E-Mail</h2>
                                    <p>Gib deinen Namen und deine E-Mail-Adresse ein. Wir senden dir einen Anmeldelink zu.</p>
                                    <p style={{ fontSize: '14px', color: 'var(--text-muted)' }}>Wichtig: Überprüfe auch den Spam-Ordner.</p>

                                    <form>
                                        <div className="field">
                                            <label htmlFor="login-vorname">Dein Vorname</label>
                                            <input
                                                id="login-vorname"
                                                type="text"
                                                pattern="\w{2,30}"
                                                maxLength="30"
                                                minLength="2"
                                                className="in_vorname"
                                                name="vorname"
                                                placeholder="Vorname"
                                                autoFocus
                                                value={formData.formVorname}
                                                autoComplete='given-name'
                                                onInput={(e) => { setFormData(prev => ({ ...prev, formVorname: capFirstChar(e.target.value) })); setFormError(false); }}
                                            />
                                        </div>
                                        <div className="field">
                                            <label htmlFor="login-nachname">Dein Nachname</label>
                                            <input
                                                id="login-nachname"
                                                type="text"
                                                pattern="\w{2,30}"
                                                maxLength="30"
                                                minLength="2"
                                                className="in_nachname"
                                                name="nachname"
                                                placeholder="Nachname"
                                                value={formData.formNachname}
                                                autoComplete='family-name'
                                                onInput={(e) => { setFormData(prev => ({ ...prev, formNachname: capFirstChar(e.target.value) })); setFormError(false); }}
                                            />
                                        </div>
                                        <div className="field">
                                            <label htmlFor="login-mail">Deine E-Mail-Adresse</label>
                                            <input
                                                id="login-mail"
                                                type="email"
                                                className="in_mail"
                                                name="mail"
                                                placeholder="E-Mail"
                                                value={formData.formMail}
                                                autoComplete='email'
                                                onInput={(e) => setFormData(prev => ({ ...prev, formMail: e.target.value }))}
                                            />
                                        </div>

                                        {(formError) ? (
                                            <span className="error-msg"><FontAwesomeIcon icon={faCircleInfo} /> Bitte fülle alle Pflichtfelder korrekt aus.</span>
                                        ) : null}

                                        <CTAButton variant="primary" block={true} title={"Einloggen"} onclick={() => doLoginRequest()} />

                                        <p className="responseInfo" id="mail_responseInfo_loading">Lädt... Bitte warten...</p>
                                        <p className="responseInfo" id="mail_responseInfo_wronginput">
                                            Bitte überprüfe deine Eingaben!<br />
                                            Fehler: {resError}
                                        </p>
                                        <p className="responseInfo" id="mail_responseInfo_servererror">
                                            Es gab einen Fehler bei der Verarbeitung.<br />
                                            Fehler: {resError}
                                        </p>
                                        <p className="responseInfo" id="mail_responseInfo_done">
                                            Erfolgreich. Bitte prüfe jetzt deine Mail.<br />
                                            In dieser findest du einen Anmeldelink.
                                        </p>
                                    </form>
                                </div>
                            )}

                            <div style={{ marginTop: '16px', display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                                {(eventid != 0 && eventid != null && eventFound != 0) ?
                                    <a className="action_third_a" href={'/event/' + eventid}>Abbrechen</a> :
                                    <a className="action_third_a" href={'/'}>Abbrechen</a>}
                                <a className="action_third_a" href={'/register'}>
                                    <FontAwesomeIcon icon={faUserPlus} /> Neu hier? Jetzt registrieren
                                </a>
                            </div>
                        </div>

                        {/* Info-Karte */}
                        <div className='card auth-card'>
                            <h2><FontAwesomeIcon icon={faLock} /> Noch kein Passwort?</h2>
                            <p>Wenn du dich bisher immer per E-Mail-Link angemeldet hast, kannst du dich wie gewohnt einloggen und danach unter Profil → Accountsicherheit einen Passkey oder ein Passwort einrichten.</p>
                            <a href='#' className='btn btn-secondary btn-block' onClick={(e) => { e.preventDefault(); switchLoginTab('mail') }}>
                                Zum E-Mail-Login <FontAwesomeIcon icon={faArrowRight} />
                            </a>
                        </div>
                    </motion.div>

                    {/* Event-Kontext: Eckdaten-Box */}
                    {(eventid != 0 && eventid != null && eventFound != 0) ? (
                        <div className='auth-event-info'>
                            <div className='card info-card'>
                                <h2><FontAwesomeIcon icon={faCircleInfo} /> {eventData.eventInfo.box3Header}</h2>
                                <div className="kv-list">
                                    <div className="kv"><b>Anmeldezeitraum</b> {formatDateWithTime(new Date(eventData.eventDates.applicationStart))} – {formatDateWithTime(new Date(eventData.eventDates.applicationEnd))}</div>
                                    <div className="kv"><b>Veranstaltungszeitraum</b> {formatDateWithTime(new Date(eventData.eventDates.dateStart))} – {formatDateWithTime(new Date(eventData.eventDates.dateEnd))}</div>
                                    <div className="kv"><b>Inhalte</b> {eventData.eventInfo.box3Contents}</div>
                                    <div className="kv"><b>Benötigte Helfer</b> {eventData.eventInfo.box3LookingFor}</div>
                                </div>
                                <p>{eventData.eventInfo.box3Text}</p>
                                <div className="contact-list">
                                    {(eventData.eventContactMail != "") ? (
                                        <a href={"mailto:" + eventData.eventContactMail}><FontAwesomeIcon icon={faEnvelopeOpenText} /> {eventData.eventContactMail}</a>
                                    ) : null}
                                    {(eventData.eventContactTel != "") ? (
                                        <a href={"tel:" + eventData.eventContactTel}><FontAwesomeIcon icon={faLock} /> {eventData.eventContactTel}</a>
                                    ) : null}
                                    <a href={eventData.eventURL} target='_blank' rel='noopener noreferrer'><FontAwesomeIcon icon={faArrowRight} /> Webseite des Veranstalters</a>
                                </div>
                                <CTAButton variant="secondary" size="sm" title={eventData.eventInfo.box3CtaText} onclick={() => oP(eventData.eventContactURL)} />
                            </div>
                        </div>
                    ) : null}
                </div>
            </main>

            <MainFooter useEventStyle={true} />
        </div>
    )
}
